import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseService } from '@mt-ng2/base-service';
import { IRecommendedPage } from '../model/recommended-page';

@Injectable()
export class RecommendedPageService extends BaseService<IRecommendedPage> {
    constructor(public http: HttpClient) {
        super('/recommendedPages', http);
    }
}
